import { memo, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Alert, Modal, ModalBody } from 'react-bootstrap';
import { FaHeart, FaRegHeart } from 'react-icons/fa6';
import { useNavigate, useParams } from 'react-router-dom';
import { styled } from 'styled-components';
import Loader from '../../components/loader';
import { AGENT_PROFILE_URL, COMMUNITY_IMAGE_URL, LOAN_OFFICER_PROFILE_URL } from '../../constants/common';
import { MainContext } from '../../context';
import {
  getAgent,
  getCommunity,
  getCommunityDescription,
  getHighlights,
  getImages,
  scheduleTour,
  sendAgentMessage,
} from '../../services/general';
import { getUserType } from '../../utils/common';
import getSubdomain from '../../utils/getSubdomain';
import {
  CommunityNameButtons,
  CommunityNameDetails,
  CommunityNameDetailsWrapper,
  HeroAndCommunityNameWrapper,
  HeroLeftCol,
  HeroRightCol,
  HeroRightColImage,
  HeroRightColImages,
  HeroWrapper,
  HighlightIcon,
  HighlightsWrapper,
  HomesButton,
  MediaPreview,
  SectionAgentContainer,
  SectionAgentContentWrapper,
  SectionAgentForm,
  SectionAgentFormField,
  SectionAgentFormFieldText,
  SectionAgentLeftCol,
  SectionAgentRightCol,
  SectionBuilderDescriptionWrapper,
  SectionBuilderDetailsContainer,
  SectionBuilderDetailsContent,
  SectionBuilderDetailsContentLeftCol,
  SectionBuilderDetailsContentRightCol,
  SectionBuilderDetailsContentText,
  SectionBuilderDetailsContentWrapper,
  SectionBuilderDetailsWrapper,
  SectionBuilderLogoWrapper,
  SectionDetails,
  SectionDetailsLeftCol,
  SectionDetailsRightCol,
  SectionGallery,
  SectionGalleryImage,
  SectionGalleryImages,
  SectionGalleryMediaWrapper,
  SectionGalleryVideo,
  SectionGalleryWrapper,
  SectionHeader,
  SectionOfficerButtonsWrapper,
  SectionOfficerCol,
  SectionOfficerContainer,
  SectionOfficerDetails,
  SectionOfficerDetailsWrapper,
  SectionOfficerNameTitle,
  SectionOfficerContactDetails,
} from '../Admin/addCommunity';
import { StaticNavigation } from '../Admin/layout';
import './Community.scss';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import axios from 'axios';
import Slider from 'react-slick';
import { ToastContainer, toast } from 'react-toastify';
import { ContinueReading } from '../../components/common';
import { addFavoriteCommunity, loftyLogin } from '../../services/user';
import { getLocalStorage } from '../../utils/storage';
import { UserStaticNavigation } from '../User/components';
import _, { isEqual } from 'lodash';
import { createPopup } from '@typeform/embed';

const CommunityContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
  align-self: stretch;

  @media (min-width: 600px) {
    gap: 160px;
  }

  & .w-100 {
    width: 100%;
  }

  & .cover {
    object-fit: cover;
  }

  & .h-100 {
    height: 100%;
  }

  & .h-450 {
    height: 100%;
    max-height: 100%;
  }

  & .hero-right-col-image {
    & > img {
      height: 349px;
    }
  }

  & .facts-card {
    & label > span {
      font-weight: 400;
    }
  }

  & .section__description p {
    color: var(--ywh-raisin-black, #2f2f2f);
    text-align: center;
    font-family: Montserrat;
    font-size: 39px;
    font-style: normal;
    font-weight: 400;
    line-height: 50.7px; /* 130% */
  }

  & .section__details-text p {
    color: #2f2f2f;
    text-align: justify;

    font-size: 18px;
    font-weight: 400;
    line-height: 28px; /* 150% */
  }
`;

const CommunityNameWrapper = styled.div`
  display: flex;
  padding: 32px 48px;
  max-width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.25);
  margin: -250px 32px 0;
  @media (max-width: 600px) {
    max-width: calc(100% - 1rem);
    margin-left: 0px;
    margin-right: 0px;
    padding: 1rem 2rem;
  }
  @media (min-width: 993px) {
    max-width: 1100px;
    width: 100%;
    margin: -250px auto 0;
  }

  & .community__name-details {
    & h2 {
      color: #000;
      text-align: center;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 56px;
    }

    & h4 {
      color: #000;
      text-align: center;
      font-size: 24px;
      font-weight: 700;
      line-height: 36px;
    }
    & p {
      color: #000;
      text-align: center;
      font-size: 18px;
      font-weight: 400;
      line-height: 28px; /* 162% */
    }
  }
`;

export const ScheduleModal = styled(Modal)`
  & .modal-content {
    background: transparent;
    border: none;
  }
  .tour-card__form-wrapper,
  .tour-card__form,
  .tour-card__calendar {
    width: 100%;
  }

  .select-btn--regular {
    color: #000;
  }
  @media (max-width: 767px) {
    .tour-card__calendar .slick-slider {
      max-width: 280px !important;
    }
  }
`;

export const GalleryModal = styled(Modal)`
  & .modal-dialog {
    max-width: 1400px;
  }

  & .modal-body {
    padding: 1px;
    position: relative;
    & > span.close {
      cursor: pointer;
      position: absolute;
      right: 20px;
      top: 20px;
      z-index: 100;
    }
  }

  & .slick-slide img {
    border-radius: var(--bs-modal-border-radius) !important;
  }
  & .slick-prev,
  & .slick-next {
    width: 64px;
    height: 64px;
  }

  & .slick-prev {
    z-index: 10;
  }
`;

const getMonth = (index) => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  return months[index];
};

const getDayShorten = (index) => {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  return days[index];
};
const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate() + 1);
tomorrow.setHours(0, 0, 0);

const INIT_TOUR = {
  name: '',
  email: '',
  phone: '',
  message: '',
  schedule: tomorrow,
  preferred_time: '',
  tour_type: 1,
};

const INIT_SEND_AGENT = {
  name: '',
  email: '',
  phone: '',
  message: '',
};

const gallerySliderSettings = {
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  initialSlide: 3,
  prevArrow: (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
      <path
        d="M32 64C38.329 64 44.5159 62.1232 49.7782 58.607C55.0406 55.0908 59.1421 50.0931 61.5641 44.2459C63.9861 38.3986 64.6198 31.9645 63.3851 25.7571C62.1504 19.5497 59.1027 13.8479 54.6274 9.37259C50.1521 4.89731 44.4503 1.84961 38.2429 0.614882C32.0355 -0.619847 25.6014 0.0138622 19.7541 2.43587C13.9069 4.85787 8.90917 8.95939 5.39296 14.2218C1.87676 19.4841 -3.35083e-06 25.671 -2.79753e-06 32C0.00895485 40.4842 3.38325 48.6183 9.38247 54.6175C15.3817 60.6167 23.5158 63.991 32 64ZM22.8738 30.2585L35.1815 17.9508C35.4102 17.7221 35.6817 17.5407 35.9805 17.4169C36.2794 17.2931 36.5996 17.2294 36.9231 17.2294C37.2465 17.2294 37.5668 17.2931 37.8656 17.4169C38.1644 17.5407 38.4359 17.7221 38.6646 17.9508C38.8933 18.1795 39.0747 18.451 39.1985 18.7498C39.3223 19.0486 39.386 19.3689 39.386 19.6923C39.386 20.0157 39.3223 20.336 39.1985 20.6348C39.0747 20.9336 38.8933 21.2052 38.6646 21.4339L28.0954 32L38.6646 42.5662C39.1265 43.028 39.386 43.6545 39.386 44.3077C39.386 44.9609 39.1265 45.5874 38.6646 46.0492C38.2027 46.5111 37.5763 46.7706 36.9231 46.7706C36.2699 46.7706 35.6434 46.5111 35.1815 46.0492L22.8738 33.7415C22.645 33.5129 22.4634 33.2415 22.3395 32.9426C22.2157 32.6438 22.1519 32.3235 22.1519 32C22.1519 31.6765 22.2157 31.3562 22.3395 31.0574C22.4634 30.7586 22.645 30.4871 22.8738 30.2585Z"
        fill="#CDA07D"
      />
      <path
        d="M22.8738 30.2585L35.1815 17.9508C35.4102 17.7221 35.6817 17.5407 35.9805 17.4169C36.2794 17.2931 36.5996 17.2294 36.9231 17.2294C37.2465 17.2294 37.5668 17.2931 37.8656 17.4169C38.1644 17.5407 38.4359 17.7221 38.6646 17.9508C38.8933 18.1795 39.0747 18.451 39.1985 18.7498C39.3223 19.0486 39.386 19.3689 39.386 19.6923C39.386 20.0157 39.3223 20.336 39.1985 20.6348C39.0747 20.9336 38.8933 21.2052 38.6646 21.4339L28.0954 32L38.6646 42.5662C39.1265 43.028 39.386 43.6545 39.386 44.3077C39.386 44.9609 39.1265 45.5874 38.6646 46.0492C38.2027 46.5111 37.5763 46.7706 36.9231 46.7706C36.2699 46.7706 35.6434 46.5111 35.1815 46.0492L22.8738 33.7415C22.645 33.5129 22.4634 33.2415 22.3395 32.9426C22.2157 32.6438 22.1519 32.3235 22.1519 32C22.1519 31.6765 22.2157 31.3562 22.3395 31.0574C22.4634 30.7586 22.645 30.4871 22.8738 30.2585Z"
        fill="white"
      />
    </svg>
  ),
  nextArrow: (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
      <path
        d="M32 0C25.671 0 19.4841 1.87677 14.2218 5.39297C8.95939 8.90918 4.85787 13.9069 2.43587 19.7541C0.013865 25.6014 -0.619842 32.0355 0.614885 38.2429C1.84961 44.4503 4.89732 50.1521 9.3726 54.6274C13.8479 59.1027 19.5497 62.1504 25.7571 63.3851C31.9645 64.6199 38.3986 63.9861 44.2459 61.5641C50.0931 59.1421 55.0908 55.0406 58.607 49.7782C62.1232 44.5159 64 38.329 64 32C63.991 23.5158 60.6167 15.3817 54.6175 9.38248C48.6183 3.38326 40.4842 0.00895944 32 0ZM41.1262 33.7415L28.8185 46.0492C28.5898 46.2779 28.3183 46.4593 28.0194 46.5831C27.7206 46.7069 27.4004 46.7706 27.0769 46.7706C26.7535 46.7706 26.4332 46.7069 26.1344 46.5831C25.8356 46.4593 25.5641 46.2779 25.3354 46.0492C25.1067 45.8205 24.9253 45.549 24.8015 45.2502C24.6777 44.9514 24.614 44.6311 24.614 44.3077C24.614 43.9843 24.6777 43.664 24.8015 43.3652C24.9253 43.0664 25.1067 42.7948 25.3354 42.5661L35.9046 32L25.3354 21.4338C24.8735 20.972 24.614 20.3455 24.614 19.6923C24.614 19.0391 24.8735 18.4127 25.3354 17.9508C25.7973 17.4889 26.4237 17.2294 27.0769 17.2294C27.7301 17.2294 28.3566 17.4889 28.8185 17.9508L41.1262 30.2585C41.355 30.4871 41.5366 30.7585 41.6605 31.0574C41.7843 31.3562 41.8481 31.6765 41.8481 32C41.8481 32.3235 41.7843 32.6438 41.6605 32.9426C41.5366 33.2414 41.355 33.5129 41.1262 33.7415Z"
        fill="#CDA07D"
      />
      <path
        d="M41.1262 33.7415L28.8185 46.0492C28.5898 46.2779 28.3183 46.4593 28.0194 46.5831C27.7206 46.7069 27.4004 46.7706 27.0769 46.7706C26.7535 46.7706 26.4332 46.7069 26.1344 46.5831C25.8356 46.4593 25.5641 46.2779 25.3354 46.0492C25.1067 45.8205 24.9253 45.549 24.8015 45.2502C24.6777 44.9514 24.614 44.6311 24.614 44.3077C24.614 43.9843 24.6777 43.664 24.8015 43.3652C24.9253 43.0664 25.1067 42.7948 25.3354 42.5661L35.9046 32L25.3354 21.4338C24.8735 20.972 24.614 20.3455 24.614 19.6923C24.614 19.0391 24.8735 18.4127 25.3354 17.9508C25.7973 17.4889 26.4237 17.2294 27.0769 17.2294C27.7301 17.2294 28.3566 17.4889 28.8185 17.9508L41.1262 30.2585C41.355 30.4871 41.5366 30.7585 41.6605 31.0574C41.7843 31.3562 41.8481 31.6765 41.8481 32C41.8481 32.3235 41.7843 32.6438 41.6605 32.9426C41.5366 33.2414 41.355 33.5129 41.1262 33.7415Z"
        fill="white"
      />
    </svg>
  ),
};

const sliderSettings = {
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: <img src="https://bucket.ywhdev.com/wl/?id=O2Sn57iluv4VB7jKfYdD6aC5zYJMQ3OH&fmode=open" alt="" />,
  nextArrow: <img src="https://bucket.ywhdev.com/wl/?id=xVvbeIxqKMg7ii1L6l1hswvyAaiQ9qAy&fmode=open" alt="" />,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};

const CommunityNotFound = styled.h3`
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
  text-align: center !important;
  margin-top: 165px !important;
`;

const QuickFactsContainer = styled.div`
  background-color: #f4f4f6;
  width: 100%;
  margin-top: -300px;
  height: auto;
  @media (min-width: 600px) {
    margin-top: -400px;
  }
  @media (min-width: 993px) {
    height: 615px;
  }
`;

const QuickFactsCardContainer = styled.div`
  display: flex;
  padding: 350px 1rem 100px;
  @media (min-width: 600px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  flex-flow: row wrap;
  gap: 24px;
  @media (min-width: 993px) {
    max-width: 1100px;
    justify-content: space-between;
  }
`;

const QuickFactsCard = styled.div`
  width: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 600px) {
    width: 160px;
  }

  & .svg-container {
    padding: 24px;
    background-color: #3c4d7d;
    border-radius: 16px 16px 0 0;
    width: 150px;
    height: 108px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .content-container {
    padding: 8px 8px 16px 8px;
    border-top: 6px solid #c3cada;
    text-align: center;
    width: 150px;
    background-color: white;
    border-radius: 0 0 16px 16px;
  }

  & p {
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;

    & span {
      color: #7c6a40;
    }
  }
`;

const FavoriteButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  background-color: transparent;
  color: red;
  padding: 0;

  &:hover {
    background-color: transparent;
  }
`;

const Community = () => {
  const navigate = useNavigate();
  let { state, market, community, id } = useParams();
  const [images, setImages] = useState([]);
  const [communityObj, setCommunity] = useState({});
  const [builder, setBuilder] = useState([]);
  const [address, setAddress] = useState({});
  const [description, setDescription] = useState({});
  const [highlights, setHighlights] = useState([]);
  const [chd, setCHD] = useState([]);
  const {
    loading,
    setLoading,
    isLoggedIn,
    setCommunityData,
    setActivePage,
    subdomainAgent,
    activeUser,
    setActiveUser,
    setSubdomainAgent,
  } = useContext(MainContext);
  const [showSchedule, setShowSchedule] = useState(false);
  const [tour, setTour] = useState(INIT_TOUR);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [agent, setAgent] = useState(null);
  const [loanOfficer, setLoanOfficer] = useState(null);

  const [messageSubmitting, setMessageSubmitting] = useState(false);
  const [messageError, setMessageError] = useState(false);
  const [messageSuccess, setMessageSuccess] = useState(false);
  const [sendAgent, setSendAgent] = useState(INIT_SEND_AGENT);

  const [gsettings, setGsettings] = useState(gallerySliderSettings);
  const fetchImages = async () => {
    let params = {
      state,
      market,
      community,
      id,
    };
    let result = await getImages(params);
    if (result.result && result.images.length > 0) {
      setImages(result.images);
    } else {
      let images = [
        {
          url: 'https://bucket.ywhdev.com/wl/?id=T6VyFbi5L2k4UQbG77RVIOatpczIkoTx&fmode=open',
        },
        {
          url: 'https://bucket.ywhdev.com/wl/?id=4e2Zg6J7oQIMQaqjtZGJW0nooxZvBq7Z&fmode=open',
        },
      ];
      setImages(images);
    }
  };
  const fetchCommunity = async () => {
    setLoading(true);
    let params = {
      state: state,
      market: market,
      community: community,
      id: id,
    };

    let result = await getCommunity(params);
    if (result.result) {
      setCommunity(result.community);
      setCommunityData(result.community);
      setBuilder(result.builder);
      setAddress(result.address);

      fetchImages();
      fetchDescription();
      fetchHighlights();
      fetchAgent();
    } else {
      navigate('/error/404', { replace: true });
    }
    setLoading(false);
  };

  const fetchDescription = async () => {
    let params = {
      state: state,
      market: market,
      community: community,
      id,
    };
    let result = await getCommunityDescription(params);
    if (result.result) {
      const { community_description } = result;
      setDescription(community_description);
      setCHD((community_description && community_description.split('\n').filter((s) => s != '')) || []);
    }
  };

  const fetchHighlights = async () => {
    let params = {
      state: state,
      market: market,
      community: community,
      id,
    };
    let result = await getHighlights(params);
    if (result.result) {
      setHighlights(result.highlights);
    }
  };

  const getRandomImageUrl = useCallback(
    (location = '') => {
      if (images?.length > 0) {
        let locationImage = images.find((img) => img.location === location);
        console.log({ locationImage });
        if (locationImage) {
          if (locationImage.url.includes('http'))
            return locationImage.url.replace('nhs-dynamic.secure.footprint.net', 'nhs-dynamic-secure.akamaized.net');
          return COMMUNITY_IMAGE_URL + locationImage.url;
        }
        const randomIndex = Math.floor(Math.random() * images.length);
        if (images[randomIndex]?.url.startsWith('http'))
          return images[randomIndex]?.url.replace(
            'nhs-dynamic.secure.footprint.net',
            'nhs-dynamic-secure.akamaized.net',
          );
        return (
          COMMUNITY_IMAGE_URL +
          images[randomIndex]?.url.replace('nhs-dynamic.secure.footprint.net', 'nhs-dynamic-secure.akamaized.net')
        );
        //return 'https://picsum.photos/700?random='+randomIndex;
      }
      return 'https://bucket.ywhdev.com/wl/?id=IgqYC6AWWscCgRIG0jB8u57GBWOK1J2K&fmode=open';
    },
    [images],
  );

  const viewHomesClick = () => {
    if (communityObj.url) {
      let url = communityObj.url.replace(
        'https://www.newhomesource.com',
        `https://www.showingnew.com/${
          (subdomainAgent && subdomainAgent.showingnew_identifier) ||
          (agent && agent.showingnew_identifier) ||
          'yourwayhome'
        }`,
      );

      if (!url.includes('showingnew') && !url.includes('newhomesource')) {
        window.open(url);
      } else {
        axios
          .get(url)
          .then((_) => window.open(url))
          .catch((_) => {
            toast.warning(
              'The community page you requested is still under construction! ' +
                'Contact us for more details about this community.',
              {
                position: 'top-center',
                draggable: false,
                hideProgressBar: true,
              },
            );
          });
      }
    } else {
      if (communityObj.fallback_nhs_url) {
        window.open(communityObj.fallback_nhs_url);
      } else {
        toast.warning(
          'The community page you requested is still under construction! ' +
            'Contact us for more details about this community.',
          {
            position: 'top-center',
            draggable: false,
            hideProgressBar: true,
          },
        );
      }
    }
  };

  const searchResaleClick = async () => {
    let key = encodeURIComponent(address.city + ', ' + state.toUpperCase());
    let minPrice = communityObj.price_min ?? 0;
    let maxPrice = communityObj.price_max ?? 0;

    if (minPrice === 0) {
      minPrice = 200000;
    } else if (minPrice > 100000) {
      minPrice = minPrice - 100000;
    }

    if (maxPrice === 0) {
      maxPrice = 3000000;
    } else {
      maxPrice = maxPrice + 500000;
    }

    const year = new Date().getFullYear();
    let condition = JSON.stringify({
      location: {
        city: [key],
      },
      price: minPrice + ',' + maxPrice,
      yearbuilt: `${year - 10}, ${year + 1}`,
    });

    let url =
      'https://www.yourwayhome.net/listing?keywordType=city&page=1&listingSource=all%20listings&zoom=10&page=1&condition=' +
      encodeURI(condition);

    if (activeUser && activeUser.user_role_id == 3) {
      const response = await loftyLogin({ lofty_website_url: url });
      if (response.result) {
        window.open(response.data);
      } else window.open(url);
    } else window.open(url);
  };

  const fetchAgent = async () => {
    if (subdomainAgent || (activeUser && activeUser.assigned_agent_id)) {
      return;
    }

    let params = {
      state: state,
      market: market,
      community: community,
      id,
    };
    const result = await getAgent(params);
    if (result.result) {
      setAgent(result.agent);
    }
  };

  useEffect(() => {
    if (!isEqual(subdomainAgent, agent)) {
      if (subdomainAgent) {
        setAgent(subdomainAgent);
        if (subdomainAgent.loan_officer) {
          setLoanOfficer(subdomainAgent.loan_officer);
        }
      }
    }
  }, [subdomainAgent, agent]);

  useEffect(() => {
    fetchCommunity();
    setActivePage('communities');
  }, [id]);

  useEffect(() => {
    if (communityObj && Object.keys(communityObj).length > 0 && address && Object.keys(address).length > 0) {
      const cm = communityObj;
      window.history.pushState(
        {},
        null,
        `/community/${cm.slug.substring(0, 2)}/${_.kebabCase(address.city)}/${_.kebabCase(cm.name)}/${cm.id}`,
      );

      //load assign loan officer if no subdomain agent
      if (!subdomainAgent && communityObj.loan_officer) {
        setLoanOfficer(communityObj.loan_officer);
      }
    }
  }, [communityObj]);

  const [showGalleryModal, setShowGalleryModal] = useState(false);

  const sendSchedule = async (data) => {
    let params = {
      state: state,
      market: market,
      community: community,
      id,
    };
    try {
      if (subdomainAgent) {
        data.agent_id = subdomainAgent.id;
      }
      await scheduleTour(params, data);
      setSubmitting(false);
      setSuccess(true);
      setTour(INIT_TOUR);
      setTimeout(() => setSuccess(false), 3000);
    } catch (e) {
      setSubmitting(false);
      setError(true);
    }
  };

  const handleTourSubmit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    sendSchedule({
      ...tour,
      schedule: tour.schedule.toISOString().split('T')[0],
    });
  };
  const handleTourChange = (e) => {
    const { name, value } = e.target;
    setTour({
      ...tour,
      [name]: value,
    });
  };

  const form = useRef(null);
  const agentForm = useRef(null);
  const gallerySliderRef = useRef(null);
  const handleSendAgentChange = (e) => {
    setMessageError(false);
    setMessageSuccess(false);
    const { name, value } = e.target;
    setSendAgent({
      ...sendAgent,
      [name]: value,
    });
  };

  const handleAgentFormSubmit = (e) => {
    e.preventDefault();
    sendMessage(sendAgent);
  };

  const sendMessage = async (data) => {
    setMessageSubmitting(true);
    let params = {
      state: state,
      market: market,
      community: community,
      id,
    };
    try {
      if (subdomainAgent) {
        data.agent_id = subdomainAgent.id;
      }
      await sendAgentMessage(params, data);
      setMessageSuccess(true);
      setMessageSubmitting(false);
      setSendAgent(INIT_SEND_AGENT);
      setTimeout(() => setMessageSuccess(false), 3000);
    } catch (e) {
      setMessageError(true);
      setMessageSubmitting(false);
    }
  };

  useEffect(() => {
    setError(false);
  }, [tour]);

  const hero_0 = useMemo(() => getRandomImageUrl('hero_0'), [getRandomImageUrl]);
  const hero_1 = useMemo(() => getRandomImageUrl('hero_1'), [getRandomImageUrl]);
  const hero_2 = useMemo(() => getRandomImageUrl('hero_2'), [getRandomImageUrl]);
  const hero_3 = useMemo(() => getRandomImageUrl('hero_3'), [getRandomImageUrl]);
  const hero_4 = useMemo(() => getRandomImageUrl('hero_4'), [getRandomImageUrl]);

  const chdImages = useMemo(
    () => chd?.map((_, index) => getRandomImageUrl(`section_${index + 1}`)) ?? [],
    [chd, getRandomImageUrl],
  );

  const handleAddToFavorites = async () => {
    let response = await addFavoriteCommunity({
      id: communityObj.id,
    });

    if (response.result) {
      let favorites = [...(activeUser.favorites ?? [])];

      if (favorites.includes(communityObj.id)) {
        favorites = favorites.filter((items) => items !== communityObj.id);
      } else {
        favorites.push(communityObj.id);
      }

      setActiveUser({ ...activeUser, favorites });
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="community-page-custom-toast">
      {isLoggedIn &&
        (getUserType() == 2 || (getLocalStorage('agent_id') && agent && getLocalStorage('agent_id') == agent.id)) && (
          <StaticNavigation page="view-community" />
        )}
      {isLoggedIn && getUserType() == 3 && (
        <UserStaticNavigation
          activeUser={activeUser}
          setActiveUser={setActiveUser}
          setSubdomainAgent={setSubdomainAgent}
          top={116}
        />
      )}
      {loading && <Loader />}
      {communityObj ? (
        <>
          <CommunityContainer className="bg-white">
            <HeroAndCommunityNameWrapper style={{ zIndex: 2 }}>
              <HeroWrapper>
                <HeroLeftCol>
                  <img className="w-100 h-100 cover" src={hero_0} alt="" />
                </HeroLeftCol>
                <HeroRightCol>
                  <HeroRightColImages>
                    <HeroRightColImage className="hero-right-col-image">
                      <img className="w-100 cover" src={hero_1} alt="" />
                    </HeroRightColImage>
                    <HeroRightColImage className="hero-right-col-image">
                      <img className="w-100 cover" src={hero_2} alt="" />
                    </HeroRightColImage>
                    <HeroRightColImage className="hero-right-col-image">
                      <img className="w-100 cover" src={hero_3} alt="" />
                    </HeroRightColImage>
                    <HeroRightColImage className="hero-right-col-image">
                      <img className="w-100 cover" src={hero_4} alt="" />
                    </HeroRightColImage>
                  </HeroRightColImages>
                </HeroRightCol>
              </HeroWrapper>
              <CommunityNameWrapper>
                <CommunityNameDetailsWrapper>
                  <CommunityNameDetails className="community__name-details" style={{ position: 'relative' }}>
                    <h2>{communityObj.name}</h2>
                    {!!activeUser && (
                      <FavoriteButton onClick={handleAddToFavorites}>
                        {activeUser?.favorites?.includes(communityObj.id) ? <FaHeart /> : <FaRegHeart />}
                      </FavoriteButton>
                    )}
                    {builder && builder?.name && !builder.name.toLowerCase().includes('no record') && (
                      <h4>Community by: {builder.name}</h4>
                    )}
                    <ContinueReading description={communityObj.description} />
                  </CommunityNameDetails>
                  <CommunityNameButtons>
                    <HomesButton onClick={viewHomesClick}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                        <path
                          d="M21.2236 19.4949C21.7631 18.6488 22.0696 17.6312 22.0696 16.5522C22.0696 13.487 19.6175 11.0348 16.5522 11.0348C13.487 11.0348 11.0348 13.487 11.0348 16.5522C11.0348 19.6175 13.487 22.0696 16.5522 22.0696C17.6189 22.0696 18.6243 21.7631 19.4703 21.2359L23.2957 25L25 23.2957L21.2236 19.4949ZM16.5522 19.6175C15.7393 19.6175 14.9596 19.2945 14.3848 18.7197C13.8099 18.1448 13.487 17.3652 13.487 16.5522C13.487 15.7393 13.8099 14.9596 14.3848 14.3848C14.9596 13.8099 15.7393 13.487 16.5522 13.487C17.3652 13.487 18.1448 13.8099 18.7197 14.3848C19.2945 14.9596 19.6175 15.7393 19.6175 16.5522C19.6175 17.3652 19.2945 18.1448 18.7197 18.7197C18.1448 19.2945 17.3652 19.6175 16.5522 19.6175ZM3.67827 20.8436V11.0348H0L12.2609 0L24.5218 11.0348H22.2903C21.2342 9.92917 19.8797 9.15396 18.3914 8.80334L12.2609 3.29819L6.13046 8.8156V18.3914H8.80334C9.01177 19.2742 9.36734 20.0956 9.84551 20.8436H3.67827Z"
                          fill="white"
                        />
                      </svg>
                      View New Homes
                    </HomesButton>
                    <HomesButton onClick={searchResaleClick}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                        <path
                          d="M21.2236 19.4949C21.7631 18.6488 22.0696 17.6312 22.0696 16.5522C22.0696 13.487 19.6175 11.0348 16.5522 11.0348C13.487 11.0348 11.0348 13.487 11.0348 16.5522C11.0348 19.6175 13.487 22.0696 16.5522 22.0696C17.6189 22.0696 18.6243 21.7631 19.4703 21.2359L23.2957 25L25 23.2957L21.2236 19.4949ZM16.5522 19.6175C15.7393 19.6175 14.9596 19.2945 14.3848 18.7197C13.8099 18.1448 13.487 17.3652 13.487 16.5522C13.487 15.7393 13.8099 14.9596 14.3848 14.3848C14.9596 13.8099 15.7393 13.487 16.5522 13.487C17.3652 13.487 18.1448 13.8099 18.7197 14.3848C19.2945 14.9596 19.6175 15.7393 19.6175 16.5522C19.6175 17.3652 19.2945 18.1448 18.7197 18.7197C18.1448 19.2945 17.3652 19.6175 16.5522 19.6175ZM3.67827 20.8436V11.0348H0L12.2609 0L24.5218 11.0348H22.2903C21.2342 9.92917 19.8797 9.15396 18.3914 8.80334L12.2609 3.29819L6.13046 8.8156V18.3914H8.80334C9.01177 19.2742 9.36734 20.0956 9.84551 20.8436H3.67827Z"
                          fill="white"
                        />
                      </svg>
                      Search for Resale Homes
                    </HomesButton>
                  </CommunityNameButtons>
                </CommunityNameDetailsWrapper>
              </CommunityNameWrapper>
            </HeroAndCommunityNameWrapper>
            <QuickFactsContainer>
              <QuickFactsCardContainer>
                <QuickFactsCard>
                  <div className="svg-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="62" height="62" viewBox="0 0 62 62" fill="none">
                      <path
                        d="M31.0006 0.5H31C24.9677 0.5 19.0708 2.28879 14.0551 5.64017C9.03942 8.99156 5.13016 13.755 2.82169 19.3282C0.513215 24.9013 -0.0907865 31.0338 1.08606 36.9502C2.26291 42.8667 5.16775 48.3012 9.43325 52.5667C13.6988 56.8322 19.1333 59.7371 25.0498 60.9139C30.9662 62.0908 37.0987 61.4868 42.6718 59.1783C48.245 56.8698 53.0084 52.9606 56.3598 47.9449C59.7112 42.9292 61.5 37.0323 61.5 31V30.9994C61.4905 22.9134 58.2741 15.1612 52.5564 9.44356C46.8388 3.72587 39.0866 0.509497 31.0006 0.5ZM30.9995 56.9706C25.8631 56.9705 20.8422 55.4473 16.5715 52.5937C12.3007 49.7401 8.97197 45.684 7.00632 40.9385C5.04067 36.193 4.52636 30.9712 5.52844 25.9334C6.53052 20.8956 9.00398 16.2681 12.636 12.636C16.2681 9.00397 20.8956 6.53051 25.9334 5.52843C30.9712 4.52635 36.193 5.04065 40.9385 7.0063C45.684 8.97196 49.7401 12.3007 52.5938 16.5715C55.4473 20.8422 56.9705 25.8631 56.9706 30.9994C56.963 37.8851 54.2243 44.4865 49.3554 49.3554C44.4865 54.2243 37.8851 56.9629 30.9995 56.9706ZM40.2903 42.6432C41.8181 41.1153 42.6765 39.0431 42.6765 36.8823C42.6765 34.7216 41.8181 32.6494 40.2903 31.1215C38.7624 29.5936 36.6902 28.7353 34.5294 28.7353H27.4706C26.5111 28.7353 25.591 28.3541 24.9125 27.6757C24.2341 26.9973 23.8529 26.0771 23.8529 25.1176C23.8529 24.1582 24.2341 23.238 24.9125 22.5596C25.591 21.8811 26.5111 21.5 27.4706 21.5H38.0588C38.6595 21.5 39.2355 21.2614 39.6602 20.8367C40.0849 20.412 40.3235 19.8359 40.3235 19.2353C40.3235 18.6347 40.0849 18.0586 39.6602 17.6339C39.2355 17.2092 38.6595 16.9706 38.0588 16.9706H33.2647V14.5294C33.2647 13.9288 33.0261 13.3527 32.6014 12.928C32.1767 12.5033 31.6006 12.2647 31 12.2647C30.3994 12.2647 29.8233 12.5033 29.3986 12.928C28.9739 13.3527 28.7353 13.9288 28.7353 14.5294V16.9706H27.4706C25.3099 16.9706 23.2376 17.8289 21.7098 19.3568C20.1819 20.8847 19.3235 22.9569 19.3235 25.1176C19.3235 27.2784 20.1819 29.3506 21.7098 30.8785C23.2376 32.4063 25.3099 33.2647 27.4706 33.2647H34.5294C35.4889 33.2647 36.409 33.6458 37.0875 34.3243C37.7659 35.0027 38.1471 35.9229 38.1471 36.8823C38.1471 37.8418 37.7659 38.762 37.0875 39.4404C36.409 40.1188 35.4889 40.5 34.5294 40.5H23.9412C23.3405 40.5 22.7645 40.7386 22.3398 41.1633C21.9151 41.588 21.6765 42.1641 21.6765 42.7647C21.6765 43.3653 21.9151 43.9414 22.3398 44.3661C22.7645 44.7908 23.3405 45.0294 23.9412 45.0294H28.7353V47.4706C28.7353 48.0712 28.9739 48.6473 29.3986 49.072C29.8233 49.4967 30.3994 49.7353 31 49.7353C31.6006 49.7353 32.1767 49.4967 32.6014 49.072C33.0261 48.6472 33.2647 48.0712 33.2647 47.4706V45.0294H34.5294C36.6902 45.0294 38.7624 44.1711 40.2903 42.6432Z"
                        fill="white"
                        stroke="white"
                      />
                    </svg>
                  </div>
                  <div className="content-container">
                    <p>
                      Min: <span>${communityObj.price_min ?? 0}</span>
                    </p>
                    <p>
                      Max: <span>${communityObj.price_max ?? 0}</span>
                    </p>
                  </div>
                </QuickFactsCard>
                <QuickFactsCard>
                  <div className="svg-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
                      <path
                        d="M34 24.107V28.0266H26V24.107V22.9151L25.1496 23.7502L19.1496 29.6431L18.7864 29.9998L19.1496 30.3565L25.1496 36.2494L26 37.0846V35.8927V31.973H34V35.8927V37.0846L34.8504 36.2494L40.8504 30.3565L41.2136 29.9998L40.8504 29.6431L34.8504 23.7502L34 22.9151V24.107ZM15 17.7141H14.5V18.2141V41.7855V42.2855H15H18H18.5V41.7855V18.2141V17.7141H18H15ZM42 17.7141H41.5V18.2141V41.7855V42.2855H42H45H45.5V41.7855V18.2141V17.7141H45H42Z"
                        fill="white"
                        stroke="white"
                      />
                      <circle cx="30" cy="30" r="27" stroke="white" stroke-width="6" />
                    </svg>
                  </div>
                  <div className="content-container">
                    <p>
                      Min: <span>{communityObj.area_min ?? 0} sq.ft</span>
                    </p>
                    <p>
                      Max: <span>{communityObj.area_max ?? 0} sq.ft</span>
                    </p>
                  </div>
                </QuickFactsCard>
                <QuickFactsCard>
                  <div className="svg-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="62" height="60" viewBox="0 0 62 60" fill="none">
                      <path
                        d="M33.1237 2.14987L33.1236 2.14982C32.304 1.33043 31.1925 0.870117 30.0335 0.870117C28.8745 0.870117 27.763 1.33043 26.9433 2.14982L26.9433 2.14984L1.21406 27.875L1.21403 27.875C0.987656 28.1014 0.808085 28.3701 0.68557 28.6659C0.563057 28.9617 0.5 29.2787 0.5 29.5988C0.5 29.919 0.563057 30.236 0.685571 30.5317C0.808085 30.8275 0.987656 31.0963 1.21403 31.3226C1.67122 31.7798 2.29129 32.0367 2.93785 32.0367C3.25799 32.0367 3.57499 31.9736 3.87077 31.8511C4.16654 31.7286 4.43529 31.549 4.66167 31.3226L4.66194 31.3224L6.30865 29.6731V48.9527C6.30865 50.6252 6.97306 52.2292 8.1557 53.4118C9.33835 54.5944 10.9424 55.2588 12.6149 55.2588H28.0981C28.744 55.2588 29.3634 55.0023 29.8202 54.5455C30.2769 54.0888 30.5335 53.4694 30.5335 52.8234C30.5335 52.1775 30.2769 51.5581 29.8202 51.1014C29.3634 50.6446 28.744 50.3881 28.0981 50.3881H12.6149C12.2342 50.3881 11.8691 50.2368 11.5999 49.9676C11.3307 49.6985 11.1795 49.3334 11.1795 48.9527V24.801L30.0335 5.94719L55.4053 31.3226L55.4053 31.3226C55.8625 31.7798 56.4826 32.0367 57.1291 32.0367C57.7757 32.0367 58.3958 31.7798 58.8529 31.3226C59.3101 30.8654 59.567 30.2454 59.567 29.5988C59.567 28.9523 59.3101 28.3322 58.853 27.875L58.8529 27.8749L49.8875 18.9135V6.3742C49.8875 5.72829 49.6309 5.10884 49.1742 4.65212C48.7175 4.1954 48.098 3.93881 47.4521 3.93881H43.5813C42.9354 3.93881 42.3159 4.1954 41.8592 4.65212L42.2128 5.00567L41.8592 4.65212C41.4025 5.10884 41.1459 5.72829 41.1459 6.3742V10.172L33.1237 2.14987ZM45.5168 43.6467H46.0168V43.1467V39.276C46.0168 38.8953 46.168 38.5302 46.4372 38.261C46.7064 37.9918 47.0715 37.8406 47.4522 37.8406C47.8329 37.8406 48.198 37.9918 48.4672 38.261C48.7364 38.5302 48.8876 38.8953 48.8876 39.276V43.1467V43.6467H49.3876H53.2584C53.6391 43.6467 54.0042 43.798 54.2734 44.0671C54.5426 44.3363 54.6938 44.7014 54.6938 45.0821C54.6938 45.4628 54.5426 45.8279 54.2734 46.0971C54.0042 46.3663 53.6391 46.5175 53.2584 46.5175H49.3876H48.8876V47.0175V50.8883C48.8876 51.269 48.7363 51.634 48.4672 51.9032C48.198 52.1724 47.8329 52.3236 47.4522 52.3236C47.0715 52.3236 46.7064 52.1724 46.4372 51.9032C46.168 51.634 46.0168 51.2689 46.0168 50.8883V47.0175V46.5175H45.5168H41.646C41.2653 46.5175 40.9002 46.3663 40.631 46.0971C40.3618 45.8279 40.2106 45.4628 40.2106 45.0821C40.2106 44.7014 40.3618 44.3363 40.631 44.0671C40.9002 43.798 41.2653 43.6467 41.646 43.6467H45.5168ZM57.3855 55.0153C60.02 52.3809 61.5 48.8078 61.5 45.0821C61.5 41.3564 60.02 37.7833 57.3855 35.1489C54.751 32.5144 51.1779 31.0344 47.4522 31.0344C43.7265 31.0344 40.1533 32.5144 37.5189 35.1489C34.8844 37.7833 33.4044 41.3564 33.4044 45.0821C33.4044 48.8078 34.8844 52.3809 37.5189 55.0153C40.1533 57.6498 43.7265 59.1298 47.4522 59.1298C51.1779 59.1298 54.751 57.6498 57.3855 55.0153Z"
                        fill="white"
                        stroke="white"
                      />
                    </svg>
                  </div>
                  <div className="content-container">
                    <p>
                      <span style={{ fontSize: 20, lineHeight: '32px' }}>{communityObj.homes ?? 0}</span>
                    </p>
                    <p>New Homes</p>
                  </div>
                </QuickFactsCard>
                <QuickFactsCard>
                  <div className="svg-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="62" height="60" viewBox="0 0 62 60" fill="none">
                      <path
                        d="M26.9433 2.14983L26.9433 2.14986L1.21406 27.8752L1.21403 27.8753C0.987654 28.1016 0.808084 28.3704 0.685571 28.6662L1.14751 28.8575L0.68557 28.6662C0.563057 28.9619 0.5 29.2789 0.5 29.5991C0.5 29.9192 0.563057 30.2362 0.68557 30.532L1.14751 30.3407L0.685571 30.532C0.808083 30.8278 0.987653 31.0965 1.21403 31.3229C1.44041 31.5493 1.70915 31.7288 2.00492 31.8514C2.3007 31.9739 2.61771 32.0369 2.93785 32.0369C3.25799 32.0369 3.575 31.9739 3.87077 31.8514C4.16654 31.7288 4.43529 31.5493 4.66167 31.3229L4.66194 31.3226L6.30865 29.6734V48.9531C6.30865 50.6256 6.97306 52.2296 8.1557 53.4123C9.33834 54.5949 10.9424 55.2593 12.6149 55.2593H28.0981C28.744 55.2593 29.3635 55.0027 29.8202 54.546C30.2769 54.0893 30.5335 53.4698 30.5335 52.8239C30.5335 52.178 30.2769 51.5586 29.8202 51.1018C29.3635 50.6451 28.744 50.3885 28.0981 50.3885H12.6149C12.2342 50.3885 11.8691 50.2373 11.5999 49.9681C11.3307 49.6989 11.1795 49.3338 11.1795 48.9531V24.8012L30.0335 5.94723L55.4053 31.3229L55.4053 31.3229C55.6317 31.5493 55.9004 31.7288 56.1962 31.8514C56.492 31.9739 56.809 32.0369 57.1291 32.0369C57.4493 32.0369 57.7663 31.9739 58.0621 31.8514C58.3578 31.7288 58.6266 31.5493 58.853 31.3229L58.4994 30.9693L58.853 31.3229C59.0793 31.0965 59.2589 30.8278 59.3814 30.532C59.5039 30.2362 59.567 29.9192 59.567 29.5991C59.567 29.2789 59.5039 28.9619 59.3814 28.6662C59.2589 28.3704 59.0793 28.1016 58.853 27.8753L58.8529 27.8752L49.8875 18.9136V6.37424C49.8875 5.72833 49.6309 5.10888 49.1742 4.65215C48.7175 4.19543 48.098 3.93884 47.4521 3.93884H43.5813C42.9354 3.93884 42.3159 4.19543 41.8592 4.65215C41.4025 5.10888 41.1459 5.72833 41.1459 6.37424V10.1721L33.1237 2.14988L33.1236 2.14983C32.304 1.33043 31.1925 0.870117 30.0335 0.870117C28.8745 0.870117 27.763 1.33043 26.9433 2.14983ZM45.1629 41.6595L42.6624 44.1638C42.3932 44.4334 42.028 44.585 41.647 44.5853C41.266 44.5856 40.9005 44.4345 40.6309 44.1653C40.3614 43.8961 40.2098 43.5308 40.2095 43.1498C40.2092 42.7689 40.3603 42.4034 40.6295 42.1338L46.4355 36.3278L46.4359 36.3274C46.5692 36.1937 46.7276 36.0877 46.902 36.0153C47.0764 35.9429 47.2634 35.9057 47.4522 35.9057C47.641 35.9057 47.8279 35.9429 48.0023 36.0153C48.1767 36.0877 48.3351 36.1937 48.4684 36.3274L49.3224 37.1835V37.1775L54.2751 42.1302C54.5447 42.3998 54.6962 42.7655 54.6962 43.1469C54.6962 43.5282 54.5447 43.894 54.2751 44.1636C54.0054 44.4332 53.6397 44.5847 53.2584 44.5847C52.8772 44.5847 52.5116 44.4333 52.2419 44.1639L52.2417 44.1636L49.7414 41.6595L48.8876 40.8043V42.0127V52.8239C48.8876 53.2046 48.7363 53.5697 48.4672 53.8389C48.198 54.1081 47.8329 54.2593 47.4522 54.2593C47.0715 54.2593 46.7064 54.1081 46.4372 53.8389C46.168 53.5697 46.0168 53.2046 46.0168 52.8239V42.0127V40.8043L45.1629 41.6595ZM47.4522 59.1301C51.1779 59.1301 54.751 57.6501 57.3855 55.0156C60.02 52.3811 61.5 48.808 61.5 45.0823C61.5 41.3566 60.02 37.7835 57.3855 35.149C54.751 32.5145 51.1779 31.0345 47.4522 31.0345C43.7265 31.0345 40.1533 32.5145 37.5189 35.149C34.8844 37.7835 33.4044 41.3566 33.4044 45.0823C33.4044 48.808 34.8844 52.3811 37.5189 55.0156C40.1533 57.6501 43.7265 59.1301 47.4522 59.1301Z"
                        fill="white"
                        stroke="white"
                      />
                    </svg>
                  </div>
                  <div className="content-container">
                    <p>
                      <span style={{ fontSize: 20, lineHeight: '32px' }}>{communityObj.quick_move_ins ?? 0}</span>
                    </p>
                    <p>Quick Move-Ins</p>
                  </div>
                </QuickFactsCard>
                <QuickFactsCard>
                  <div className="svg-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="62" height="58" viewBox="0 0 62 58" fill="none">
                      <mask
                        id="path-1-outside-1_2978_9529"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0.418213"
                        width="62"
                        height="58"
                        fill="black"
                      >
                        <rect fill="white" y="0.418213" width="62" height="58" />
                        <path d="M28.1722 2.58919C28.9223 1.83942 29.9394 1.41821 31 1.41821C32.0606 1.41821 33.0777 1.83942 33.8278 2.58919L42.999 11.7599V6.58863C42.999 6.05827 43.2097 5.54964 43.5847 5.17462C43.9598 4.7996 44.4684 4.58891 44.9988 4.58891H48.9985C49.5289 4.58891 50.0375 4.7996 50.4126 5.17462C50.7876 5.54964 50.9983 6.05827 50.9983 6.58863V19.7588L60.4135 29.1694C60.5995 29.3554 60.747 29.5761 60.8476 29.819C60.9482 30.0619 61 30.3223 61 30.5852C61 30.8482 60.9482 31.1085 60.8476 31.3515C60.747 31.5944 60.5995 31.8151 60.4135 32.001C60.2276 32.187 60.0068 32.3345 59.7639 32.4351C59.521 32.5357 59.2606 32.5875 58.9976 32.5875C58.7347 32.5875 58.4743 32.5357 58.2314 32.4351C57.9884 32.3345 57.7677 32.187 57.5818 32.001L31 5.41679L11.0017 25.414V50.5824C11.0017 51.1128 11.2124 51.6214 11.5874 51.9964C11.9625 52.3715 12.4711 52.5821 13.0015 52.5821H29.0002C29.5306 52.5821 30.0392 52.7928 30.4143 53.1678C30.7893 53.5429 31 54.0515 31 54.5819C31 55.1122 30.7893 55.6208 30.4143 55.9959C30.0392 56.3709 29.5306 56.5816 29.0002 56.5816H13.0015C11.4104 56.5816 9.88436 55.9495 8.75923 54.8245C7.63411 53.6994 7.00202 52.1735 7.00202 50.5824V29.4134L4.41824 32.001C4.2323 32.187 4.01156 32.3345 3.76863 32.4351C3.52569 32.5357 3.26531 32.5875 3.00236 32.5875C2.7394 32.5875 2.47903 32.5357 2.23609 32.4351C1.99315 32.3345 1.77241 32.187 1.58648 32.001C1.40054 31.8151 1.25305 31.5944 1.15242 31.3515C1.05179 31.1085 1 30.8482 1 30.5852C1 30.3223 1.05179 30.0619 1.15242 29.819C1.25305 29.5761 1.40054 29.3554 1.58648 29.1694L28.1722 2.58919Z" />
                        <path d="M41.525 30.7883C42.1656 28.6067 45.2548 28.6067 45.899 30.7883L46.052 31.315C46.1476 31.6417 46.3152 31.9428 46.5425 32.1962C46.7698 32.4496 47.0511 32.6489 47.3655 32.7793C47.68 32.9097 48.0196 32.968 48.3596 32.9498C48.6995 32.9317 49.0311 32.8376 49.3299 32.6744L49.8139 32.4111C51.8105 31.3221 53.9957 33.5072 52.9102 35.5037L52.6433 35.9877C52.4808 36.2863 52.3872 36.6175 52.3694 36.957C52.3516 37.2965 52.41 37.6357 52.5404 37.9496C52.6708 38.2636 52.8698 38.5444 53.1229 38.7715C53.3759 38.9985 53.6766 39.166 54.0028 39.2617L54.5331 39.4219C56.7112 40.0625 56.7112 43.1515 54.5331 43.7956L53.9993 43.9486C53.6731 44.045 53.3727 44.2132 53.1201 44.4409C52.8675 44.6685 52.6691 44.9498 52.5394 45.2641C52.4097 45.5785 52.352 45.9179 52.3706 46.2574C52.3892 46.5969 52.4836 46.928 52.6468 47.2263L52.9102 47.7103C53.9957 49.7068 51.8105 51.8918 49.8139 50.8064L49.3299 50.5395C49.0312 50.377 48.7 50.2835 48.3605 50.2657C48.021 50.2479 47.6818 50.3063 47.3678 50.4367C47.0538 50.567 46.7729 50.766 46.5459 51.0191C46.3188 51.2721 46.1513 51.5727 46.0556 51.899L45.8954 52.4292C45.2548 54.6072 42.1656 54.6072 41.5215 52.4292L41.3684 51.8954C41.272 51.5693 41.1038 51.2689 40.8762 51.0163C40.6485 50.7637 40.3672 50.5653 40.0528 50.4356C39.7385 50.3059 39.3991 50.2482 39.0595 50.2668C38.72 50.2854 38.3889 50.3798 38.0906 50.5431L37.6066 50.8064C35.61 51.8918 33.4248 49.7068 34.5103 47.7103L34.7772 47.2263C34.9397 46.9277 35.0332 46.5964 35.051 46.257C35.0688 45.9174 35.0104 45.5783 34.88 45.2643C34.7497 44.9503 34.5506 44.6695 34.2976 44.4425C34.0445 44.2154 33.7439 44.0479 33.4176 43.9522L32.8909 43.7956C30.7093 43.1515 30.7093 40.0625 32.8909 39.4183L33.4176 39.2653C33.7444 39.1697 34.0455 39.0021 34.299 38.7748C34.5524 38.5475 34.7516 38.2663 34.882 37.9519C35.0125 37.6375 35.0708 37.2978 35.0526 36.9579C35.0345 36.6179 34.9403 36.2864 34.7772 35.9877L34.5138 35.5037C33.4248 33.5072 35.61 31.3221 37.6066 32.4075L38.0906 32.6744C38.3892 32.8369 38.7205 32.9305 39.06 32.9483C39.3995 32.9661 39.7387 32.9077 40.0527 32.7773C40.3667 32.6469 40.6475 32.4479 40.8746 32.1949C41.1016 31.9418 41.2691 31.6412 41.3649 31.315L41.525 30.7883ZM49.0487 41.607C49.0487 40.906 48.9106 40.2118 48.6423 39.5641C48.3741 38.9165 47.9808 38.328 47.4851 37.8323C46.9894 37.3366 46.4009 36.9434 45.7532 36.6751C45.1055 36.4069 44.4113 36.2688 43.7102 36.2688C43.0092 36.2688 42.315 36.4069 41.6673 36.6751C41.0196 36.9434 40.4311 37.3366 39.9353 37.8323C39.4396 38.328 39.0464 38.9165 38.7781 39.5641C38.5098 40.2118 38.3717 40.906 38.3717 41.607C38.3717 43.0227 38.9342 44.3805 39.9353 45.3816C40.9365 46.3827 42.2944 46.9451 43.7102 46.9451C45.1261 46.9451 46.4839 46.3827 47.4851 45.3816C48.4863 44.3805 49.0487 43.0227 49.0487 41.607Z" />
                      </mask>
                      <path
                        d="M28.1722 2.58919C28.9223 1.83942 29.9394 1.41821 31 1.41821C32.0606 1.41821 33.0777 1.83942 33.8278 2.58919L42.999 11.7599V6.58863C42.999 6.05827 43.2097 5.54964 43.5847 5.17462C43.9598 4.7996 44.4684 4.58891 44.9988 4.58891H48.9985C49.5289 4.58891 50.0375 4.7996 50.4126 5.17462C50.7876 5.54964 50.9983 6.05827 50.9983 6.58863V19.7588L60.4135 29.1694C60.5995 29.3554 60.747 29.5761 60.8476 29.819C60.9482 30.0619 61 30.3223 61 30.5852C61 30.8482 60.9482 31.1085 60.8476 31.3515C60.747 31.5944 60.5995 31.8151 60.4135 32.001C60.2276 32.187 60.0068 32.3345 59.7639 32.4351C59.521 32.5357 59.2606 32.5875 58.9976 32.5875C58.7347 32.5875 58.4743 32.5357 58.2314 32.4351C57.9884 32.3345 57.7677 32.187 57.5818 32.001L31 5.41679L11.0017 25.414V50.5824C11.0017 51.1128 11.2124 51.6214 11.5874 51.9964C11.9625 52.3715 12.4711 52.5821 13.0015 52.5821H29.0002C29.5306 52.5821 30.0392 52.7928 30.4143 53.1678C30.7893 53.5429 31 54.0515 31 54.5819C31 55.1122 30.7893 55.6208 30.4143 55.9959C30.0392 56.3709 29.5306 56.5816 29.0002 56.5816H13.0015C11.4104 56.5816 9.88436 55.9495 8.75923 54.8245C7.63411 53.6994 7.00202 52.1735 7.00202 50.5824V29.4134L4.41824 32.001C4.2323 32.187 4.01156 32.3345 3.76863 32.4351C3.52569 32.5357 3.26531 32.5875 3.00236 32.5875C2.7394 32.5875 2.47903 32.5357 2.23609 32.4351C1.99315 32.3345 1.77241 32.187 1.58648 32.001C1.40054 31.8151 1.25305 31.5944 1.15242 31.3515C1.05179 31.1085 1 30.8482 1 30.5852C1 30.3223 1.05179 30.0619 1.15242 29.819C1.25305 29.5761 1.40054 29.3554 1.58648 29.1694L28.1722 2.58919Z"
                        fill="white"
                      />
                      <path
                        d="M41.525 30.7883C42.1656 28.6067 45.2548 28.6067 45.899 30.7883L46.052 31.315C46.1476 31.6417 46.3152 31.9428 46.5425 32.1962C46.7698 32.4496 47.0511 32.6489 47.3655 32.7793C47.68 32.9097 48.0196 32.968 48.3596 32.9498C48.6995 32.9317 49.0311 32.8376 49.3299 32.6744L49.8139 32.4111C51.8105 31.3221 53.9957 33.5072 52.9102 35.5037L52.6433 35.9877C52.4808 36.2863 52.3872 36.6175 52.3694 36.957C52.3516 37.2965 52.41 37.6357 52.5404 37.9496C52.6708 38.2636 52.8698 38.5444 53.1229 38.7715C53.3759 38.9985 53.6766 39.166 54.0028 39.2617L54.5331 39.4219C56.7112 40.0625 56.7112 43.1515 54.5331 43.7956L53.9993 43.9486C53.6731 44.045 53.3727 44.2132 53.1201 44.4409C52.8675 44.6685 52.6691 44.9498 52.5394 45.2641C52.4097 45.5785 52.352 45.9179 52.3706 46.2574C52.3892 46.5969 52.4836 46.928 52.6468 47.2263L52.9102 47.7103C53.9957 49.7068 51.8105 51.8918 49.8139 50.8064L49.3299 50.5395C49.0312 50.377 48.7 50.2835 48.3605 50.2657C48.021 50.2479 47.6818 50.3063 47.3678 50.4367C47.0538 50.567 46.7729 50.766 46.5459 51.0191C46.3188 51.2721 46.1513 51.5727 46.0556 51.899L45.8954 52.4292C45.2548 54.6072 42.1656 54.6072 41.5215 52.4292L41.3684 51.8954C41.272 51.5693 41.1038 51.2689 40.8762 51.0163C40.6485 50.7637 40.3672 50.5653 40.0528 50.4356C39.7385 50.3059 39.3991 50.2482 39.0595 50.2668C38.72 50.2854 38.3889 50.3798 38.0906 50.5431L37.6066 50.8064C35.61 51.8918 33.4248 49.7068 34.5103 47.7103L34.7772 47.2263C34.9397 46.9277 35.0332 46.5964 35.051 46.257C35.0688 45.9174 35.0104 45.5783 34.88 45.2643C34.7497 44.9503 34.5506 44.6695 34.2976 44.4425C34.0445 44.2154 33.7439 44.0479 33.4176 43.9522L32.8909 43.7956C30.7093 43.1515 30.7093 40.0625 32.8909 39.4183L33.4176 39.2653C33.7444 39.1697 34.0455 39.0021 34.299 38.7748C34.5524 38.5475 34.7516 38.2663 34.882 37.9519C35.0125 37.6375 35.0708 37.2978 35.0526 36.9579C35.0345 36.6179 34.9403 36.2864 34.7772 35.9877L34.5138 35.5037C33.4248 33.5072 35.61 31.3221 37.6066 32.4075L38.0906 32.6744C38.3892 32.8369 38.7205 32.9305 39.06 32.9483C39.3995 32.9661 39.7387 32.9077 40.0527 32.7773C40.3667 32.6469 40.6475 32.4479 40.8746 32.1949C41.1016 31.9418 41.2691 31.6412 41.3649 31.315L41.525 30.7883ZM49.0487 41.607C49.0487 40.906 48.9106 40.2118 48.6423 39.5641C48.3741 38.9165 47.9808 38.328 47.4851 37.8323C46.9894 37.3366 46.4009 36.9434 45.7532 36.6751C45.1055 36.4069 44.4113 36.2688 43.7102 36.2688C43.0092 36.2688 42.315 36.4069 41.6673 36.6751C41.0196 36.9434 40.4311 37.3366 39.9353 37.8323C39.4396 38.328 39.0464 38.9165 38.7781 39.5641C38.5098 40.2118 38.3717 40.906 38.3717 41.607C38.3717 43.0227 38.9342 44.3805 39.9353 45.3816C40.9365 46.3827 42.2944 46.9451 43.7102 46.9451C45.1261 46.9451 46.4839 46.3827 47.4851 45.3816C48.4863 44.3805 49.0487 43.0227 49.0487 41.607Z"
                        fill="white"
                      />
                      <path
                        d="M28.1722 2.58919C28.9223 1.83942 29.9394 1.41821 31 1.41821C32.0606 1.41821 33.0777 1.83942 33.8278 2.58919L42.999 11.7599V6.58863C42.999 6.05827 43.2097 5.54964 43.5847 5.17462C43.9598 4.7996 44.4684 4.58891 44.9988 4.58891H48.9985C49.5289 4.58891 50.0375 4.7996 50.4126 5.17462C50.7876 5.54964 50.9983 6.05827 50.9983 6.58863V19.7588L60.4135 29.1694C60.5995 29.3554 60.747 29.5761 60.8476 29.819C60.9482 30.0619 61 30.3223 61 30.5852C61 30.8482 60.9482 31.1085 60.8476 31.3515C60.747 31.5944 60.5995 31.8151 60.4135 32.001C60.2276 32.187 60.0068 32.3345 59.7639 32.4351C59.521 32.5357 59.2606 32.5875 58.9976 32.5875C58.7347 32.5875 58.4743 32.5357 58.2314 32.4351C57.9884 32.3345 57.7677 32.187 57.5818 32.001L31 5.41679L11.0017 25.414V50.5824C11.0017 51.1128 11.2124 51.6214 11.5874 51.9964C11.9625 52.3715 12.4711 52.5821 13.0015 52.5821H29.0002C29.5306 52.5821 30.0392 52.7928 30.4143 53.1678C30.7893 53.5429 31 54.0515 31 54.5819C31 55.1122 30.7893 55.6208 30.4143 55.9959C30.0392 56.3709 29.5306 56.5816 29.0002 56.5816H13.0015C11.4104 56.5816 9.88436 55.9495 8.75923 54.8245C7.63411 53.6994 7.00202 52.1735 7.00202 50.5824V29.4134L4.41824 32.001C4.2323 32.187 4.01156 32.3345 3.76863 32.4351C3.52569 32.5357 3.26531 32.5875 3.00236 32.5875C2.7394 32.5875 2.47903 32.5357 2.23609 32.4351C1.99315 32.3345 1.77241 32.187 1.58648 32.001C1.40054 31.8151 1.25305 31.5944 1.15242 31.3515C1.05179 31.1085 1 30.8482 1 30.5852C1 30.3223 1.05179 30.0619 1.15242 29.819C1.25305 29.5761 1.40054 29.3554 1.58648 29.1694L28.1722 2.58919Z"
                        stroke="white"
                        stroke-width="2"
                        mask="url(#path-1-outside-1_2978_9529)"
                      />
                      <path
                        d="M41.525 30.7883C42.1656 28.6067 45.2548 28.6067 45.899 30.7883L46.052 31.315C46.1476 31.6417 46.3152 31.9428 46.5425 32.1962C46.7698 32.4496 47.0511 32.6489 47.3655 32.7793C47.68 32.9097 48.0196 32.968 48.3596 32.9498C48.6995 32.9317 49.0311 32.8376 49.3299 32.6744L49.8139 32.4111C51.8105 31.3221 53.9957 33.5072 52.9102 35.5037L52.6433 35.9877C52.4808 36.2863 52.3872 36.6175 52.3694 36.957C52.3516 37.2965 52.41 37.6357 52.5404 37.9496C52.6708 38.2636 52.8698 38.5444 53.1229 38.7715C53.3759 38.9985 53.6766 39.166 54.0028 39.2617L54.5331 39.4219C56.7112 40.0625 56.7112 43.1515 54.5331 43.7956L53.9993 43.9486C53.6731 44.045 53.3727 44.2132 53.1201 44.4409C52.8675 44.6685 52.6691 44.9498 52.5394 45.2641C52.4097 45.5785 52.352 45.9179 52.3706 46.2574C52.3892 46.5969 52.4836 46.928 52.6468 47.2263L52.9102 47.7103C53.9957 49.7068 51.8105 51.8918 49.8139 50.8064L49.3299 50.5395C49.0312 50.377 48.7 50.2835 48.3605 50.2657C48.021 50.2479 47.6818 50.3063 47.3678 50.4367C47.0538 50.567 46.7729 50.766 46.5459 51.0191C46.3188 51.2721 46.1513 51.5727 46.0556 51.899L45.8954 52.4292C45.2548 54.6072 42.1656 54.6072 41.5215 52.4292L41.3684 51.8954C41.272 51.5693 41.1038 51.2689 40.8762 51.0163C40.6485 50.7637 40.3672 50.5653 40.0528 50.4356C39.7385 50.3059 39.3991 50.2482 39.0595 50.2668C38.72 50.2854 38.3889 50.3798 38.0906 50.5431L37.6066 50.8064C35.61 51.8918 33.4248 49.7068 34.5103 47.7103L34.7772 47.2263C34.9397 46.9277 35.0332 46.5964 35.051 46.257C35.0688 45.9174 35.0104 45.5783 34.88 45.2643C34.7497 44.9503 34.5506 44.6695 34.2976 44.4425C34.0445 44.2154 33.7439 44.0479 33.4176 43.9522L32.8909 43.7956C30.7093 43.1515 30.7093 40.0625 32.8909 39.4183L33.4176 39.2653C33.7444 39.1697 34.0455 39.0021 34.299 38.7748C34.5524 38.5475 34.7516 38.2663 34.882 37.9519C35.0125 37.6375 35.0708 37.2978 35.0526 36.9579C35.0345 36.6179 34.9403 36.2864 34.7772 35.9877L34.5138 35.5037C33.4248 33.5072 35.61 31.3221 37.6066 32.4075L38.0906 32.6744C38.3892 32.8369 38.7205 32.9305 39.06 32.9483C39.3995 32.9661 39.7387 32.9077 40.0527 32.7773C40.3667 32.6469 40.6475 32.4479 40.8746 32.1949C41.1016 31.9418 41.2691 31.6412 41.3649 31.315L41.525 30.7883ZM49.0487 41.607C49.0487 40.906 48.9106 40.2118 48.6423 39.5641C48.3741 38.9165 47.9808 38.328 47.4851 37.8323C46.9894 37.3366 46.4009 36.9434 45.7532 36.6751C45.1055 36.4069 44.4113 36.2688 43.7102 36.2688C43.0092 36.2688 42.315 36.4069 41.6673 36.6751C41.0196 36.9434 40.4311 37.3366 39.9353 37.8323C39.4396 38.328 39.0464 38.9165 38.7781 39.5641C38.5098 40.2118 38.3717 40.906 38.3717 41.607C38.3717 43.0227 38.9342 44.3805 39.9353 45.3816C40.9365 46.3827 42.2944 46.9451 43.7102 46.9451C45.1261 46.9451 46.4839 46.3827 47.4851 45.3816C48.4863 44.3805 49.0487 43.0227 49.0487 41.607Z"
                        stroke="white"
                        stroke-width="2"
                        mask="url(#path-1-outside-1_2978_9529)"
                      />
                    </svg>
                  </div>
                  <div className="content-container">
                    <p>
                      <span style={{ fontSize: 20, lineHeight: '32px' }}>1</span>
                    </p>
                    <p>Builder</p>
                  </div>
                </QuickFactsCard>
              </QuickFactsCardContainer>
            </QuickFactsContainer>
            {(!!communityObj.highlights_description || !!chd.length || !!highlights.length) && (
              <HighlightsWrapper>
                <SectionHeader title="Highlights" showH1 />
                {communityObj.highlights_description && (
                  <div className="section__content-wrapper">
                    <div className="section__description">
                      <p>{communityObj.highlights_description}</p>
                    </div>
                  </div>
                )}
                {!!highlights.length && (
                  <div className="section__highlight-card-wrapper">
                    {highlights.map((highlight) => (
                      <div className="section__highlight-card">
                        <HighlightIcon variant={highlight.name} />
                        <h5>{highlight.name}</h5>
                      </div>
                    ))}
                  </div>
                )}
                {chd.map((c, index) => (
                  <SectionDetails className="section__details">
                    <SectionDetailsLeftCol className="section__details-left-col">
                      <div className="section__details-text">
                        <p>{c}</p>
                      </div>
                    </SectionDetailsLeftCol>
                    <SectionDetailsRightCol className="section__details-right-col overflow-hidden">
                      <img src={chdImages[index]} className="w-100 h-450 cover" alt="" />
                    </SectionDetailsRightCol>
                  </SectionDetails>
                ))}
              </HighlightsWrapper>
            )}
            {agent && (
              <SectionAgentContainer>
                <SectionHeader
                  className="section-agent-header"
                  title={`Hi! I'm <span>${agent.first_name} ${agent.last_name}</span>, your local community specialist. How can I help?`}
                />
                <SectionAgentContentWrapper>
                  <SectionAgentLeftCol>
                    <div className="agent-profile">
                      <img src={`${AGENT_PROFILE_URL}${agent.photo}`} alt="" />
                      <div>
                        <h2>
                          {agent.first_name} {agent.last_name}
                        </h2>
                        <h4>{communityObj.name} Community Specialist</h4>
                        {agent.licenses && agent.licenses.filter((a) => a.license != '').length > 0 && (
                          <p>
                            License:{' '}
                            {agent.licenses &&
                              agent.licenses
                                .filter((a) => a.license != '')
                                .map((l) => l.license + '-' + l.state)
                                .join(',')}
                          </p>
                        )}
                        <p>
                          Phone: <a href={`tel:${agent.mobile_phone}`}>{agent.mobile_phone}</a>
                        </p>
                        <p>
                          Email: <a href={`mailto:${agent.email}`}>{agent.email}</a>
                        </p>
                      </div>
                    </div>
                    <div className="spacer" />
                    <div className="agent-description">
                      <p>{agent.description}</p>
                    </div>
                  </SectionAgentLeftCol>
                  <SectionAgentRightCol>
                    <p>
                      We respect your privacy! Your information WILL NOT BE SHARED, SOLD, or RENTED to anyone, for any
                      reason outside the course of normal real estate exchange. By submitting, you agree to our{' '}
                      <a href="#">Terms of Use</a> and <a href="#">Privacy Policy.</a>
                    </p>
                    <SectionAgentForm ref={agentForm} onSubmit={handleAgentFormSubmit}>
                      <SectionAgentFormField>
                        <input
                          type="text"
                          value={sendAgent.name}
                          name="name"
                          required
                          placeholder="Name"
                          onChange={handleSendAgentChange}
                        />
                      </SectionAgentFormField>
                      <SectionAgentFormField>
                        <input
                          type="email"
                          value={sendAgent.email}
                          name="email"
                          required
                          placeholder="Email"
                          onChange={handleSendAgentChange}
                        />
                      </SectionAgentFormField>
                      <SectionAgentFormField>
                        <input
                          type="text"
                          value={sendAgent.phone}
                          name="phone"
                          required
                          placeholder="Phone"
                          onChange={handleSendAgentChange}
                        />
                      </SectionAgentFormField>
                      <SectionAgentFormFieldText>
                        <textarea
                          value={sendAgent.message}
                          name="message"
                          placeholder="Message"
                          required
                          rows={6}
                          onChange={handleSendAgentChange}
                        ></textarea>
                        {messageSuccess && (
                          <Alert variant="success" className="w-100">
                            Request successfully submitted.
                          </Alert>
                        )}
                        {messageError && (
                          <Alert variant="danger" className="w-100">
                            Something went wrong, please try again
                          </Alert>
                        )}

                        <button type="submit" disabled={messageSubmitting}>
                          {messageSubmitting ? 'Submitting...' : 'SEND MESSAGE'}
                        </button>
                      </SectionAgentFormFieldText>
                    </SectionAgentForm>
                  </SectionAgentRightCol>
                </SectionAgentContentWrapper>
              </SectionAgentContainer>
            )}
            {loanOfficer && (
              <SectionAgentContainer>
                <SectionHeader
                  className="section-agent-header"
                  title={`Loan Officer: ${loanOfficer.first_name} ${loanOfficer.last_name}`}
                />
                <SectionAgentContentWrapper className="w-100">
                  <SectionOfficerCol>
                    <SectionOfficerContainer>
                      {loanOfficer ? (
                        <img src={`${LOAN_OFFICER_PROFILE_URL}${loanOfficer.headshot}`} alt="" />
                      ) : (
                        <div style={{ maxWidth: 300, width: '100%', height: 448 }}></div>
                      )}
                      <SectionOfficerDetailsWrapper>
                        <SectionOfficerDetails>
                          <SectionOfficerNameTitle>
                            <h4>{`${loanOfficer.first_name} ${loanOfficer.last_name}`}</h4>
                            <p>Loan Officer</p>
                          </SectionOfficerNameTitle>
                          <SectionOfficerContactDetails>
                            <p>
                              License: <span>{loanOfficer.nmls}</span>
                            </p>
                            <p>
                              Phone: <span>{loanOfficer.mobile_phone}</span>
                            </p>
                            <p>
                              Email: <span>{loanOfficer.email}</span>
                            </p>
                          </SectionOfficerContactDetails>
                        </SectionOfficerDetails>
                        <SectionOfficerButtonsWrapper>
                          <HomesButton
                            onClick={() =>
                              window.open(
                                'https://lenderlogix.com/apply-now/bbiwer@encompasslending.com&application=STANDARD',
                              )
                            }
                          >
                            Apply for loan
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="14"
                              viewBox="0 0 8 14"
                              fill="none"
                            >
                              <path
                                d="M0.355291 0.574666C0.242666 0.687061 0.153312 0.820565 0.0923468 0.967536C0.0313812 1.11451 0 1.27206 0 1.43117C0 1.59029 0.0313812 1.74784 0.0923468 1.89481C0.153312 2.04178 0.242666 2.17528 0.355291 2.28768L5.06911 7.0015L0.355291 11.7153C0.242813 11.8278 0.153591 11.9613 0.0927187 12.1083C0.031846 12.2553 0.000514429 12.4128 0.000514428 12.5718C0.000514427 12.7309 0.031846 12.8884 0.0927187 13.0354C0.153591 13.1823 0.242813 13.3159 0.355291 13.4283C0.467769 13.5408 0.6013 13.63 0.74826 13.6909C0.89522 13.7518 1.05273 13.7831 1.2118 13.7831C1.37087 13.7831 1.52838 13.7518 1.67534 13.6909C1.8223 13.63 1.95583 13.5408 2.0683 13.4283L7.64471 7.85193C7.75733 7.73954 7.84669 7.60603 7.90765 7.45906C7.96862 7.31209 8 7.15454 8 6.99543C8 6.83631 7.96862 6.67876 7.90765 6.53179C7.84669 6.38482 7.75733 6.25132 7.64471 6.13892L2.0683 0.562517C1.60664 0.100854 0.829103 0.100854 0.355291 0.574666Z"
                                fill="#EAEAEA"
                              />
                            </svg>
                          </HomesButton>
                          <HomesButton
                            onClick={() => {
                              createPopup('VBh5Ecrd').toggle();
                            }}
                          >
                            Check Rates
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="14"
                              viewBox="0 0 8 14"
                              fill="none"
                            >
                              <path
                                d="M0.355291 0.574666C0.242666 0.687061 0.153312 0.820565 0.0923468 0.967536C0.0313812 1.11451 0 1.27206 0 1.43117C0 1.59029 0.0313812 1.74784 0.0923468 1.89481C0.153312 2.04178 0.242666 2.17528 0.355291 2.28768L5.06911 7.0015L0.355291 11.7153C0.242813 11.8278 0.153591 11.9613 0.0927187 12.1083C0.031846 12.2553 0.000514429 12.4128 0.000514428 12.5718C0.000514427 12.7309 0.031846 12.8884 0.0927187 13.0354C0.153591 13.1823 0.242813 13.3159 0.355291 13.4283C0.467769 13.5408 0.6013 13.63 0.74826 13.6909C0.89522 13.7518 1.05273 13.7831 1.2118 13.7831C1.37087 13.7831 1.52838 13.7518 1.67534 13.6909C1.8223 13.63 1.95583 13.5408 2.0683 13.4283L7.64471 7.85193C7.75733 7.73954 7.84669 7.60603 7.90765 7.45906C7.96862 7.31209 8 7.15454 8 6.99543C8 6.83631 7.96862 6.67876 7.90765 6.53179C7.84669 6.38482 7.75733 6.25132 7.64471 6.13892L2.0683 0.562517C1.60664 0.100854 0.829103 0.100854 0.355291 0.574666Z"
                                fill="#EAEAEA"
                              />
                            </svg>
                          </HomesButton>
                        </SectionOfficerButtonsWrapper>
                      </SectionOfficerDetailsWrapper>
                    </SectionOfficerContainer>
                  </SectionOfficerCol>
                  <SectionOfficerCol>
                    <p>{loanOfficer.description}</p>
                  </SectionOfficerCol>
                </SectionAgentContentWrapper>
              </SectionAgentContainer>
            )}
            {!!images.length && (
              <SectionGalleryWrapper>
                <SectionGallery>
                  <SectionHeader title="Gallery" showH1 />
                </SectionGallery>
                <SectionGalleryMediaWrapper>
                  {images &&
                    images
                      .filter((f) => f.image_name && f.image_name.includes('mp4'))
                      .map((f, index) => (
                        <>
                          {index === 0 && (
                            <SectionGalleryVideo>
                              <MediaPreview file={f} />
                            </SectionGalleryVideo>
                          )}
                        </>
                      ))}

                  <SectionGalleryImages>
                    {images &&
                      images.length > 0 &&
                      images
                        .filter((f) => !f.location)
                        .map(
                          (f, index) =>
                            f && (
                              <SectionGalleryImage>
                                <MediaPreview
                                  file={f}
                                  handleClick={() => {
                                    setGsettings({
                                      ...gsettings,
                                      initialSlide: index,
                                    });
                                    setShowGalleryModal(!showGalleryModal);
                                  }}
                                  hasCursor
                                />
                              </SectionGalleryImage>
                            ),
                        )}
                  </SectionGalleryImages>
                </SectionGalleryMediaWrapper>
              </SectionGalleryWrapper>
            )}
            {(builder.description || builder.builder_content || builder.builder_highlight_details) && (
              <SectionBuilderDetailsContainer>
                <SectionHeader title="Builder Details" showH1 />
                <SectionBuilderDetailsWrapper>
                  <SectionBuilderDescriptionWrapper>
                    {builder.builder_image && (
                      <SectionBuilderLogoWrapper>
                        <img
                          src={getRandomImageUrl('builder_image')}
                          class="cover"
                          style={{ height: 'auto', maxWidth: 250 }}
                          alt=""
                        />
                      </SectionBuilderLogoWrapper>
                    )}
                    <p>{builder.description}</p>
                  </SectionBuilderDescriptionWrapper>
                  <SectionBuilderDetailsContentWrapper>
                    <SectionBuilderDetailsContentWrapper>
                      <SectionBuilderDetailsContent>
                        {builder.builder_content && (
                          <SectionBuilderDetailsContentLeftCol>
                            <p>{builder.builder_content}</p>
                          </SectionBuilderDetailsContentLeftCol>
                        )}
                        {builder.builder_content_image && (
                          <SectionBuilderDetailsContentRightCol>
                            <img
                              src={getRandomImageUrl('builder_content_image')}
                              class="w-100 cover"
                              height="350"
                              alt=""
                            />
                          </SectionBuilderDetailsContentRightCol>
                        )}
                      </SectionBuilderDetailsContent>
                    </SectionBuilderDetailsContentWrapper>
                    <SectionBuilderDetailsContentText>
                      <p>{builder.builder_highlight_details}</p>
                    </SectionBuilderDetailsContentText>
                  </SectionBuilderDetailsContentWrapper>
                </SectionBuilderDetailsWrapper>
              </SectionBuilderDetailsContainer>
            )}
          </CommunityContainer>
          <button class="sticky-button" onClick={() => setShowSchedule(!showSchedule)}>
            Schedule a Tour
          </button>

          <ScheduleModal
            show={showSchedule}
            centered
            onHide={() => setShowSchedule(!showSchedule)}
            className="modal-schedule"
          >
            <div class="schedule-a-tour">
              <div class="tour-card">
                <div class="tour-card__content-wrapper">
                  {/* <!-- HEADING --> */}
                  <div class="tour-card__heading">
                    <img src="https://bucket.ywhdev.com/wl/?id=XJA9n3mcBEdFUQXTYSQ6rG4cYfaOu9jF&fmode=open" alt="" />
                    <h3>Schedule a Tour</h3>
                  </div>
                  {/* <!-- SELECT BUTTON --> */}
                  <div class="select-btn">
                    <button
                      type="button"
                      onClick={() =>
                        setTour({
                          ...tour,
                          tour_type: 1,
                        })
                      }
                      class={`select-btn--${tour.tour_type == 1 ? 'active' : 'regular'}`}
                    >
                      <div>In-Person</div>
                    </button>
                    <button
                      type="button"
                      onClick={() =>
                        setTour({
                          ...tour,
                          tour_type: 2,
                        })
                      }
                      class={`select-btn--${tour.tour_type == 2 ? 'active' : 'regular'}`}
                    >
                      <div>Online Call</div>
                    </button>
                  </div>
                  <div class="tour-card__form-wrapper">
                    {/* <!-- FORM --> */}
                    <form ref={form} class="tour-card__form" onSubmit={handleTourSubmit}>
                      <>
                        <input
                          class="tour-card__form--input form-control form-control-lg mb-3"
                          type="text"
                          placeholder="Name*"
                          onChange={handleTourChange}
                          aria-label="Name Required"
                          required
                          value={tour.name}
                          name="name"
                        />
                        <div class="d-flex gap-3">
                          <input
                            class="form-control form-control-lg mb-3"
                            type="email"
                            placeholder="Email*"
                            aria-label="Email Required"
                            required
                            name="email"
                            value={tour.email}
                            onChange={handleTourChange}
                          />
                          <input
                            class="form-control form-control-lg mb-3"
                            placeholder="Phone"
                            aria-label="Phone"
                            name="phone"
                            value={tour.phone}
                            onChange={handleTourChange}
                          />
                        </div>
                        <div className="w-100">
                          <textarea
                            class="form-control form-control-lg mb-3"
                            type="text"
                            placeholder="Message"
                            aria-label="Message"
                            rows="5"
                            name="message"
                            onChange={handleTourChange}
                            value={tour.message}
                          ></textarea>
                        </div>
                      </>

                      <div class="d-flex flex-column gap-4 tour-card__calendar">
                        <div class="tour-card__month d-flex">
                          <h6>{getMonth(new Date().getMonth())}</h6>
                        </div>
                        <div class="d-flex flex-column gap-2">
                          {/* <div class="tour-card__day">Tomorrow</div> */}
                          <div class="date-card d-flex">
                            {/* <div class="date-card__nav">
													<img
														src="https://bucket.ywhdev.com/wl/?id=O2Sn57iluv4VB7jKfYdD6aC5zYJMQ3OH&fmode=open"
														alt=""
													/>
												</div> */}
                            <div class="date-card__wrapper">
                              <Slider {...sliderSettings}>
                                {Array.from(Array(7).keys()).map((value) => {
                                  const date = new Date();
                                  date.setDate(date.getDate() + (value + 1));
                                  date.setHours(0, 0, 0);
                                  return (
                                    <div
                                      class={`${
                                        date.toDateString() == tour.schedule.toDateString()
                                          ? 'date-card--active'
                                          : 'date-card--normal'
                                      }`}
                                      onClick={() =>
                                        setTour({
                                          ...tour,
                                          schedule: date,
                                        })
                                      }
                                    >
                                      <small>{getDayShorten(date.getDay())}</small>
                                      <h3>{date.getDate()}</h3>
                                    </div>
                                  );
                                })}
                              </Slider>
                            </div>
                          </div>
                        </div>
                        <div class="preferred-time">
                          <select
                            class="form-select form-select-lg mb-3"
                            aria-label="Select Preferred Time"
                            onChange={handleTourChange}
                            name="preferred_time"
                            required
                          >
                            <option selected={tour.preferred_time == ''} value="">
                              Preferred Time
                            </option>
                            <option value="Morning">Morning</option>
                            <option value="Afternoon">Afternoon</option>
                            <option value="Evening">Evening</option>
                          </select>
                        </div>
                        {success && <Alert variant="success">Request successfully submitted.</Alert>}
                        {error && <Alert variant="danger">Something went wrong, please try again</Alert>}

                        <button
                          className="btn btn-primary btn-lg schedule-card__submit-btn"
                          type="submit"
                          disabled={submitting}
                        >
                          {submitting ? 'Submitting...' : 'Submit Request'}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </ScheduleModal>

          <GalleryModal centered show={showGalleryModal} onHide={() => setShowGalleryModal(!showGalleryModal)}>
            <ModalBody>
              <span className="close" onClick={() => setShowGalleryModal(!showGalleryModal)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
                  <path
                    d="M26 0C11.6637 0 0 11.6637 0 26C0 40.3363 11.6637 52 26 52C40.3363 52 52 40.3363 52 26C52 11.6637 40.3363 0 26 0ZM36.8288 34L34 36.8288L26 28.8288L18 36.8288L15.1712 34L23.1712 26L15.1712 18L18 15.1712L26 23.1712L34 15.1712L36.8288 18L28.8288 26L36.8288 34Z"
                    fill="#04246B"
                  />
                  <path
                    d="M36.8288 34L34 36.8288L26 28.8288L18 36.8288L15.1712 34L23.1712 26L15.1712 18L18 15.1712L26 23.1712L34 15.1712L36.8288 18L28.8288 26L36.8288 34Z"
                    fill="white"
                  />
                </svg>
              </span>
              <Slider {...gsettings} ref={gallerySliderRef}>
                {images && images.map((image) => <MediaPreview file={image} />)}
              </Slider>
            </ModalBody>
          </GalleryModal>
        </>
      ) : (
        <CommunityNotFound>Community Not Found.</CommunityNotFound>
      )}

      <ToastContainer />
    </div>
  );
};

export default memo(Community);
